import { render, staticRenderFns } from "./subsection.vue?vue&type=template&id=0e1d54db&scoped=true"
import script from "./subsection.vue?vue&type=script&lang=js"
export * from "./subsection.vue?vue&type=script&lang=js"
import style0 from "./subsection.vue?vue&type=style&index=0&id=0e1d54db&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1d54db",
  null
  
)

export default component.exports